import { TableColumn } from "./dataInterface";

export const paymentConfirmSumTableColumn: TableColumn = {
  title: "明細管理",
  detail: false,
  detailTitle: "明細詳細",
  detailColumn: "詳細",
  detailKey: [],
  addTitle: "",
  editAuth: [],
  tableFunction: [],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "sum_high_rank_company_payment_value",
      name: "上位店入金額合計",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "170px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sum_partner_transfer",
      name: "パートナー振込金額合計",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "170px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sum_partner_transfer",
      name: "支払金額合計",
      tableDetailAuth: ["パートナー"],
      table: true,
      tableMinWidth: "170px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sum_sale_amount",
      name: "利益金額合計",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "170px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "rate_profit",
      name: "利益率",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "170px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
  ],
  subTable: [],
};
